import { Input, List, Modal, Typography } from "antd";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

import { flattenMenuLeaves } from "@/routes/menuMeta";
import { hasPermission } from "@/utils/permissions";

export function CommandPalette({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [q, setQ] = useState("");

  const filtered = useMemo(() => {
    const perms = qc.getQueryData<string[]>(["admin", "me", "permissions"]) ?? [];
    const routes = flattenMenuLeaves().filter((l) =>
      hasPermission(perms, l.requiredPermissions)
    );
    const s = q.trim().toLowerCase();
    if (!s) return routes;
    return routes.filter(
      (r) =>
        t(r.labelKey).toLowerCase().includes(s) || r.path.toLowerCase().includes(s)
    );
  }, [q, qc, t]);

  const onPick = (path: string) => {
    navigate(path);
    setQ("");
    onClose();
  };

  return (
    <Modal
      title={t("common.search")}
      open={open}
      footer={null}
      onCancel={() => {
        setQ("");
        onClose();
      }}
      destroyOnClose
    >
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        ⌘/Ctrl + K 打开；输入路径或中文名称过滤。
      </Typography.Text>
      <Input
        style={{ marginTop: 12, marginBottom: 8 }}
        value={q}
        onChange={(e) => setQ(e.target.value)}
        aria-label={t("common.search")}
        placeholder={t("common.search")}
      />
      <List
        size="small"
        dataSource={filtered}
        locale={{ emptyText: "无匹配路由（或当前权限不足）" }}
        renderItem={(item) => (
          <List.Item
            style={{ cursor: "pointer" }}
            onClick={() => onPick(item.path)}
          >
            <div>
              <div>{t(item.labelKey)}</div>
              <Typography.Text code type="secondary">
                {item.path}
              </Typography.Text>
            </div>
          </List.Item>
        )}
      />
    </Modal>
  );
}
